<template lang="pug">
a.reveal-field(@click="toggle")
  b-icon(:icon="icon" size="is-small")
  span {{ label }}
  input(ref="input")
</template>

<script>
import { HTTP } from '@/utils/http';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'reveal-field',
  computed: {
    icon() {
      return this.display ? 'lock-open' : 'lock';
    },
    label() {
      return this.display ? this.display : '************';
    },
  },
  data() {
    return {
      display: null,
    };
  },
  methods: {
    async toggle() {
      if (this.display) {
        this.display = null;
      } else {
        const params = {};
        params[this.field] = true;
        const { data } = await HTTP.get(`/${this.resource}/${this.value.id}`, { params });
        const obj = data.data[this.resource][0];
        this.display = obj[this.field];
        const input = this.$refs.input;
        input.setAttribute('value', this.display);
        input.focus();
        input.select();
        document.execCommand('copy');
        const capitalized = this.$options.filters.capitalize(this.field);
        this.$store.commit(mutations.SET_APP_SNACKBAR, {
          type: 'is-success',
          message: `${capitalized} copied to clipboard`,
        });
      }
    },
  },
  props: {
    field: {
      type: String,
      default: null,
    },
    resource: {
      type: String,
      default: null,
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.reveal-field {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  input {
    position:absolute;
    left: -9999px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RevealField.vue